export const apiConstants = {
  url: "/api/course",
  courseTypes: "/api/courseType",
  locations: "/api/location",
  courseCategories: "/api/courseCategory",
  courseWeek: "/api/courseWeek",
  children: "/api/child",
  sendRegistration: "/api/send-registration",
  peopleCourseWeekRegistration: "/api/peopleCourseWeekRegistration"
};
